import {
  LIST_CLINIC_VISITS_FAIL,
  LIST_CLINIC_VISITS_REQUEST,
  LIST_CLINIC_VISITS_RESET,
  LIST_CLINIC_VISITS_SUCCESS,
  LIST_PATIENT_VISITS_FAIL,
  LIST_PATIENT_VISITS_REQUEST,
  LIST_PATIENT_VISITS_RESET,
  LIST_PATIENT_VISITS_SUCCESS,
  VISIT_CREATE_FAIL,
  VISIT_CREATE_REQUEST,
  VISIT_CREATE_RESET,
  VISIT_CREATE_SUCCESS,
  VISIT_DELETE_FAIL,
  VISIT_DELETE_REQUEST,
  VISIT_DELETE_RESET,
  VISIT_DELETE_SUCCESS,
  VISIT_SCAN_UPDATE_FAIL,
  VISIT_SCAN_UPDATE_REQUEST,
  VISIT_SCAN_UPDATE_RESET,
  VISIT_SCAN_UPDATE_SUCCESS,
  VISIT_UPDATE_FAIL,
  VISIT_UPDATE_REQUEST,
  VISIT_UPDATE_RESET,
  VISIT_UPDATE_SUCCESS,
} from "../constants/visitConstants";

export const newVisitReducer = (state = { noRequest: true }, action) => {
  switch (action.type) {
    case VISIT_CREATE_REQUEST:
      return { loading: true };
    case VISIT_CREATE_SUCCESS:
      return { loading: false, newVisit: action.payload };
    case VISIT_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case VISIT_CREATE_RESET:
      return { noRequest: true };
    default:
      return state;
  }
};

export const patientVisitReducer = (state = { noRequest: true }, action) => {
  switch (action.type) {
    case LIST_PATIENT_VISITS_REQUEST:
      return { loading: true };
    case LIST_PATIENT_VISITS_SUCCESS:
      return { loading: false, patientVisits: action.payload };
    case LIST_PATIENT_VISITS_FAIL:
      return { loading: false, error: action.payload };
    case LIST_PATIENT_VISITS_RESET:
      return { noRequest: true };
    default:
      return state;
  }
};

export const clinicVisitReducer = (state = { noRequest: true }, action) => {
  switch (action.type) {
    case LIST_CLINIC_VISITS_REQUEST:
      return { loading: true };
    case LIST_CLINIC_VISITS_SUCCESS:
      return {
        loading: false,
        clinicVisits: action.payload.visits,
        csv: action.payload.csv,
      };
    case LIST_CLINIC_VISITS_FAIL:
      return { loading: false, error: action.payload };
    case LIST_CLINIC_VISITS_RESET:
      return { noRequest: true };
    default:
      return state;
  }
};

export const visitScanUpdateReducer = (state = { noRequest: true }, action) => {
  switch (action.type) {
    case VISIT_SCAN_UPDATE_REQUEST:
      return { loading: true };
    case VISIT_SCAN_UPDATE_SUCCESS:
      return { loading: false, updatedScan: action.payload };
    case VISIT_SCAN_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case VISIT_SCAN_UPDATE_RESET:
      return { noRequest: true };
    default:
      return state;
  }
};
